module.exports = __webpack_public_path__ + "img/BMM_Color.0e2ba8c7.png";